enum SECTION_NAMES {
    GENERAL = 'General',
    USERS_AND_GROUPS = 'Users & Groups',
    TEMPLATES = 'Templates',
    ROOMS_AND_DEVICES = 'Rooms & Devices',
    CONTAINERS = 'Containers',
    SERVERS_AND_SERVICES = 'Servers & Services',
    LOGS = 'Logs',
    ALERTS = 'Alerts',
    HELP = 'Help',
    ANNOUNCEMENT = 'Announcements',
    SESSION_TRACKS = 'VALT Cue',
    CIRCUIT = 'Circuit',
}

export default SECTION_NAMES;
